function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.41214 9.15408H4.58786C3.54856 9.15408 2.70307 8.31425 2.70307 7.28195C2.70307 6.24961 3.54862 5.40977 4.58786 5.40977H8.23636C8.70665 5.40977 9.08792 5.03105 9.08792 4.56391C9.08792 4.09677 8.70665 3.71804 8.23636 3.71804H6.35156V1.84586C6.35156 1.37872 5.97029 1 5.5 1C5.02971 1 4.64844 1.37872 4.64844 1.84586V3.71804H4.58792C2.60951 3.71804 1 5.31684 1 7.28195C1 9.24707 2.60957 10.8458 4.58792 10.8458H6.41219C7.45144 10.8458 8.29693 11.6857 8.29693 12.718C8.29693 13.7503 7.45144 14.5902 6.41219 14.5902H2.7637C2.29341 14.5902 1.91214 14.9689 1.91214 15.436C1.91214 15.9032 2.29341 16.2819 2.7637 16.2819H4.64844V18.1541C4.64844 18.6213 5.02971 19 5.5 19C5.97029 19 6.35156 18.6213 6.35156 18.1541V16.2819H6.41214C8.39049 16.2819 10 14.6831 10 12.718C10 10.7529 8.39049 9.15408 6.41214 9.15408Z",
  fill: "#D18F1F",
  stroke: "#D18F1F",
  strokeWidth: 0.1
});
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.fd8c155154df14af61294fe97103e2b8.svg";
export { ForwardRef as ReactComponent };